import { format, parseISO } from "date-fns";

export default function getMonthAsString(dateTimeString) {
  if (!dateTimeString) return null;
  const date = parseISO(dateTimeString);
  const month = format(date, "MMMM");
  return month;
}
